import React, {useEffect, useRef} from "react";

interface InputItemProps {
    children: React.ReactNode | React.ReactNodeArray,
    title?: string,
    itemKey: string,
    currentItemKey: string,
    changeItemKey: (key: string) => void,
    setRef?: Function,
}

/**
 * Scrollable item than decides for themselves when its viewer counterpart should be shown.
 * @param props
 * @constructor
 */
const InputItem = (props: InputItemProps) => {
    const {children, itemKey, currentItemKey, changeItemKey} = props;
    const ref = useRef<HTMLDivElement>();
    useEffect(() => {
        const listener = (event: Event) => {
            if (ref.current) {
                const min = ref.current.getBoundingClientRect().top;
                // If we scrolled back to the beginning, we're going to show the first InputItem.
                // Otherwise, because of different screen sizes, this might not be visible anymore after scrolling.
                if (window.scrollY < 10) {
                    changeItemKey('airco-designer');
                    return;
                } else {
                    const max = ref.current.getBoundingClientRect().bottom;
                    const vh = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0);
                    const half = vh / 2;
                    if (half > min && half < max && itemKey !== currentItemKey) {
                        changeItemKey(itemKey);
                    }
                }
            }
        };
        window.addEventListener('scroll', listener);
        return () => {
            window.removeEventListener('scroll', listener);
        }
    }, [changeItemKey, currentItemKey, itemKey]);

    return <div ref={(element: HTMLDivElement) => {if (props.setRef) props.setRef(element); ref.current = element;}} className={'item'}>
        {children}
    </div>
}

export default InputItem;